import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { Plan } from 'app/models/plan';
import Swal from 'sweetalert2';
import { PlanPieceService } from 'app/services/PlanPiece/plan-piece.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';

@Component({
  selector: 'app-plan-list',
  templateUrl: './plan-list.component.html',
  styleUrls: ['./plan-list.component.scss']
})
export class PlanListComponent implements OnInit {
  pieceId!: number;
  piece: any;
  plans: Plan[] = [];
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pieceService: PiecesService,
    private planService: PlanPieceService,
    private awsService: AwscontrolService
  ) {}

  ngOnInit(): void {
    this.pieceId = Number(this.route.snapshot.paramMap.get('pieceId'));
    this.loadPieceAndPlans();
  }

  loadPieceAndPlans(): void {
    this.loading = true;
    this.pieceService.getPiece(this.pieceId).subscribe({
      next: (piece: any) => {
        this.piece = piece;
        this.plans = piece.plans || [];
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error loading piece', err);
        this.loading = false;
        Swal.fire('Erreur', 'Impossible de charger les données', 'error');
      }
    });
  }

  async deletePlan(plan: Plan): Promise<void> {
    const result = await Swal.fire({
      title: 'Supprimer ce plan ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer'
    });

    if (result.isConfirmed && plan.id) {
      try {
        // 1. Delete associated images from S3
        await this.deleteImagesFromS3(plan);
        
        // 2. Delete the plan from backend (using toPromise)
        await this.planService.deletePlan(plan.id).toPromise();
        
        Swal.fire('Supprimé!', 'Le plan a été supprimé avec succès.', 'success');
        this.loadPieceAndPlans();
      } catch (error: any) {
        console.error('Error during deletion:', error);
        Swal.fire('Erreur', 'Échec de la suppression du plan.', 'error');
      }
    }
  }

  private async deleteImagesFromS3(plan: Plan): Promise<void> {
    const images = plan.photosPlan || [];
    if (images.length === 0) {
      return;
    }

    const deletePromises = images.map(url => 
      this.awsService.deleteFile(url).toPromise().catch((err: any) => {
        console.warn(`Failed to delete image ${url}:`, err);
        // Continue even if one fails
      })
    );

    await Promise.all(deletePromises);
  }

navigateBack(): void {
  // Redirect to the project's piece list page
  if (this.piece && this.piece.projetId) {
    this.router.navigate(['/list-appartement', this.piece.projetId]);
  } else {
    // Fallback to browser history if projetId is missing
    window.history.back();
  }
}

  addPlan(): void {
    this.router.navigate(['/piece', this.pieceId, 'plans', 'add']);
  }

  editPlan(planId: number): void {
    this.router.navigate(['/piece', this.pieceId, 'plans', 'edit', planId]);
  }
}